import { Alerta, AlertaForm, GatilhoAlertas, LocalExibicaoAlertas, ModoExibicaoAlertas, StatusAlertas, TipoAlertas, AcoesModalEnum } from '../../models/alerta';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomAlertaComponent } from '../modal-alerta/custom-alerta.component';
import { GestaoAlertasService } from '../services/gestao-alertas.service';
import { Perfil } from '@core/models/perfil.models';
import { PerfilService } from '@core/services/perfil.service';
import { MatPageable } from '@core/table/mat-table';
import { ProdutoService } from '@core/services/produto.service';
import { StatusProdutoEnum } from '@core/models/status-produto.models';
import { TipoProdutoEnum } from '@core/models/tipo-produto.models';
import { Router } from '@angular/router';
import { NotificationService } from '@core/services/notification.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-modal-gestao-alertas',
  templateUrl: './modal-gestao-alertas.component.html',
  styleUrls: ['./modal-gestao-alertas.component.scss']
})
export class ModalGestaoAlertasComponent implements OnInit, AfterViewInit {

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'Montserrat', name: 'Montserrat Thin' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['subscript',
        'superscript',
        'indent',
        'outdent',
        'backgroundColor',
        'customClasses',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
      ]
    ]
  };

  alertaForm: FormGroup;

  element: any;
  alerta: Alerta;
  acao: string;

  tiposAlertas: TipoAlertas[] = [];
  locaisExibicaoAlertas: LocalExibicaoAlertas[] = [];
  statusAlertas: StatusAlertas[] = [];
  modosExibicaoAlertas: ModoExibicaoAlertas[] = [];
  gatilhosExibicaoAlertas: GatilhoAlertas[] = [];
  perfilAlerta: Perfil[] = [];
  placeholderValue: string = "Data para término da exibição";
  produtosPortal: any[] = [];
  rotasAlertas: any[] = [];
  locaisExibicao: any[] = [];
  hasTriggerTime: boolean = false;

  acoesModalEnum = AcoesModalEnum;

  constructor(public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public modalService: NgbModal,
    private gestaoAlertasService: GestaoAlertasService,
    private perfilService: PerfilService,
    private produtoService: ProdutoService,
    private router: Router,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {

    this.alertaForm = this.formBuilder.group({
      products: [null, Validators.required],
      exhibitionModes: [null, Validators.required],
      alertType: [null],
      active: [null, Validators.required],
      alertStart: [null, Validators.required],
      alertEnd: [null, Validators.required],
      timeStart: [null, Validators.required],
      timeEnd: [null, Validators.required],
      userProfiles: [null, Validators.required],
      triggers: [null, Validators.required],
      title: ['', Validators.compose([Validators.required, Validators.maxLength(64)])],
      subTitle: ['', Validators.compose([Validators.required, Validators.maxLength(255)])],
      message: ['', Validators.required],
      triggerTime: ['']
    })


    if (this.acao == AcoesModalEnum.Visualizar) {
      this.alertaForm.disable();
    }

    this.triggers.valueChanges.subscribe((value: any[]) => {
      if (value.some(x => x.id == 4)) {
        this.hasTriggerTime = true;
        this.triggerTime.addValidators(Validators.required)
      } else {
        this.hasTriggerTime = false;
        this.triggerTime.clearValidators();
        this.triggerTime.updateValueAndValidity();
      }
    })

    this.getCampos();
  }

  ngAfterViewInit() {
    if (this.acao != AcoesModalEnum.Criar) {
      setTimeout(() => {
        this.gestaoAlertasService.getAlerta(this.idAlerta).subscribe((alerta: any) => {
          this.alerta = alerta;
          if (this.alerta) {
            this.popularCampos(this.alerta);
          }
        });
      }, 1000);
    }
  }

  getTituloModal() {
    switch (this.acao) {
      case AcoesModalEnum.Visualizar:
        return 'VISUALIZAR ALERTA';
      case AcoesModalEnum.Editar:
        return 'EDITAR ALERTA';
      case AcoesModalEnum.Criar:
        return 'CRIAR ALERTA';
    }
  }

  getCampos() {
    this.gestaoAlertasService.getTiposAlertas().subscribe(tipos => this.tiposAlertas = tipos);
    this.gestaoAlertasService.getModosExibicao().subscribe(modos => this.modosExibicaoAlertas = modos);
    this.gestaoAlertasService.getStatusAlertas().subscribe(status => this.statusAlertas = status);
    this.gestaoAlertasService.getGatilhosAlertas().subscribe(gatilhos => this.gatilhosExibicaoAlertas = gatilhos);
    this.perfilService.buscaTodosSemFiltroPerfil().subscribe(perfil => this.perfilAlerta = perfil);
    this.rotasAlertas = this.router.config.filter(
      route =>
        route.path &&
        !route.path.includes('/:')
    );
    this.getProdutos();
  }

  getProdutos() {
    this.produtoService.getProdutos(new MatPageable(), { tipoProduto: TipoProdutoEnum.Padrao }).subscribe((data) => {
      this.produtosPortal = data
        .filter(x => x.idStatusProduto == StatusProdutoEnum.Ativo)
        .map(y => ({ ...y, groupName: 'Produtos' }));
      this.getLocaisExibicao();
    })
  }

  getLocaisExibicao() {
    const rotasAdm = this.rotasAlertas.map(x => ({
      id: null,
      nome: x.path,
      groupName: 'Administrativo'
    }));

    this.locaisExibicao = [...this.produtosPortal, ...rotasAdm]
  }

  popularCampos(alerta) {
    const products = this.locaisExibicao.filter(local =>
      alerta.products && alerta.products.includes(local.id)
    );

    if (alerta.routes) {
      const routes = this.locaisExibicao.filter(local =>
        alerta.routes.includes(local.nome) && local.id === null
      );
      products.push(...routes);
    }

    const triggers = this.gatilhosExibicaoAlertas.filter(gatilho =>
      alerta.triggers.some(trigger => trigger.id === gatilho.id)
    ).map(gatilho => {
      const alertaTrigger = alerta.triggers.find(trigger => trigger.id === gatilho.id);
      return {
        ...gatilho,
        value: alertaTrigger?.value || gatilho.value
      };
    });
    const time: any = triggers.filter(trigger => trigger.id == 4);
    alerta.triggers = triggers;
    alerta.products = products;
    alerta.triggerTime = time.length ? time[0].value : null;
    this.alertaForm.patchValue(alerta);
    this.getDataHora(alerta)
  }

  getDataHora(alerta) {
    const [startDate, startTime] = alerta.alertStart.split('T');
    const [endDate, endTime] = alerta.alertEnd.split('T');

    this.alertaForm.patchValue({
      alertStart: startDate,
      timeStart: startTime?.slice(0, 5),
      alertEnd: endDate,
      timeEnd: endTime?.slice(0, 5)
    });
  }

  salvarAlerta() {
    if (this.alertaForm.valid) {
      const dataInicio = this.combineDateAndTime(this.dateStart, this.timeStart);
      const dataFinal = this.combineDateAndTime(this.dateEnd, this.timeEnd);
      let data: any = {};

      this.alertaForm.valid ? data = { ...this.alertaForm.value } : null;
      if (this.products.value) {
        data.products = [];
        data.routes = [];
        this.products.value.forEach(p => {
          if (p.id != null) {
            // É um produto (tem ID)
            data.products.push(p.id);
          } else {
            // É uma rota (não tem ID)
            data.routes.push(p.nome);
          }
        });
      }
      data.alertStart = dataInicio;
      data.alertEnd = dataFinal;
      data.triggers = this.gatilhosExibicaoAlertas
        .filter(g => this.triggers.value.some(t => t.id === g.id))
        .map(x => x.id === 4
          ? { id: x.id, value: this.triggerTime.value }
          : { id: x.id }
        );

      delete data.timeStart;
      delete data.timeEnd;
      delete data.customRoutes;
      delete data.triggerTime;
      this.criarEditarAlerta(data);
    } else {

    }
  }

  criarEditarAlerta(data, id?) {
    if (this.acao == AcoesModalEnum.Criar) {
      this.gestaoAlertasService.criarAlerta(data).subscribe(obj => {
        this.notificationService.success('Alerta criado com sucesso!');
        this.close();
      })
    } else if (this.acao == AcoesModalEnum.Editar) {
      this.gestaoAlertasService.editarAlerta(data, this.idAlerta).subscribe(obj => {
        this.notificationService.success('Alerta alterado com sucesso!');
        this.close();
      })
    }
  }


  private combineDateAndTime(date: string, time: string): string {
    if (!date || !time || !date.includes('-') || !time.includes(':')) {
      console.warn('Data ou hora inválida:', { date, time });
      return '';
    }

    const [pureDate] = date.split('T');
    const [year, month, day] = pureDate.split('-').map(Number);
    const [hour, minute] = time.split(':').map(Number);

    if (
      isNaN(year) || isNaN(month) || isNaN(day) ||
      isNaN(hour) || isNaN(minute)
    ) {
      console.warn('Valores numéricos inválidos:', { year, month, day, hour, minute });
      return '';
    }

    const localDate = new Date(year, month - 1, day, hour, minute, 0);

    if (isNaN(localDate.getTime())) {
      console.warn('Data inválida gerada:', localDate);
      return '';
    }

    return localDate.toISOString();
  }

  visualizarAlerta() {
    let component = this.modalService.open(CustomAlertaComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true, size: 'xl',
      windowClass: 'custom-alerta',
      backdropClass: 'modal-backdrop-erro',
      container: '.modal-gestao-alertas'
    });
    let instance = <CustomAlertaComponent>component.componentInstance;
    instance.alerta = { ...this.alertaForm.value };
    component.result.then((data) => {
    })
  }

  close() {
    this.activeModal.close();
  }

  get dateStart() {
    return this.alertaForm.controls.alertStart.value;
  }

  get dateEnd() {
    return this.alertaForm.controls.alertEnd.value;
  }

  get timeStart() {
    return this.alertaForm.controls.timeStart.value;
  }

  get timeEnd() {
    return this.alertaForm.controls.timeEnd.value;
  }

  get customRoutes() {
    return this.alertaForm.controls.customRoutes;
  }

  get routes() {
    return this.alertaForm.controls.routes;
  }

  get idAlerta() {
    return this.element.id;
  }

  get products() {
    return this.alertaForm.controls.products;
  }

  get triggers() {
    return this.alertaForm.controls.triggers;
  }

  get triggerTime() {
    return this.alertaForm.controls.triggerTime;
  }
}
